import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import { alumniFormCount, getContactEmail } from "../../server/apihelper";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SEO from "../../common-components/SEO";

export const Alumni = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone_no: "",
    subject: "",
    message: "",
  });
  const [alumniData, setAlumniData] = useState({
    countryCount: 0,
    alumniFormCount: 0,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await alumniFormCount();
        if (res.status) {
          setAlumniData({
            countryCount: res.data.countryCount,
            alumniFormCount: res.data.alumniFormCount,
          });
        }
      } catch (error) {
        console.error("Error fetching alumni data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      {/* Add SEO Tags */}
      <SEO
        fullTitle="McGAN'S Ooty Alumni Network | Connect with Top Architecture Graduates"
        description="Join the thriving McGAN'S Ooty alumni network and connect with architecture graduates from Tamil Nadu and beyond. Build professional relationships and explore career opportunities with our global alumni community."
        keywords="McGAN'S Ooty Alumni Network, Architecture Alumni Tamil Nadu, Connect with McGAN'S Graduates, Top Architecture Alumni Network, Alumni Community for Architecture, McGAN'S Alumni Tamil Nadu"
        url="https://mcgansarch.com/alumni"
      />
      <h1 style={{ display: "none" }}>
        Stay Connected with the McGAN'S Ooty Alumni Network
      </h1>
      <div className="page-banner-area bg-2">
        <div className="container">
          <div className="page-banner-content">
            <h3 className="BannerHeader">Alumni</h3>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li className="navspace">Alumni</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Contact Us Area */}
      <div className="contact-us-area pt-100 pb-20" >
        <div className="container">

          <div className="row">
            <div className="col-lg-12">
              <div className="contact-and-address text-center">
                <h2>Alumni Network</h2>
                <p className="mb-5">
                  <b>
                    Engage with a vibrant community of alumni, fostering
                    connections and collaborations for a brighter future.
                  </b>
                </p>

                {/* Full Page Connect Button */}
                <div className="full-page-connect-section">
                  <div className="connect-content">
                    <div className="connect-icon mb-4">
                      <i className="ri-team-line"></i>
                    </div>
                    <h3>Join Our Alumni Community</h3>
                    <p>Connect with fellow graduates, share experiences, and build lasting professional relationships</p>
                    <Link
                      to="/registration"
                      className="full-page-connect-btn"
                    >
                      <span>Connect Now</span>
                      <i className="flaticon-next"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <ToastContainer />

      {/* Custom CSS for Full Page Connect Button */}
      <style jsx>{`
        .full-page-connect-section {
          background: transparent;
          border: 1px solid rgba(0, 0, 0, 0.1);
          border-radius: 25px;
          padding: 40px 30px;
          margin: 20px 0;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
          position: relative;
          overflow: hidden;
        }
        
        .full-page-connect-section::before {
          content: '';
          position: absolute;
          top: -50%;
          right: -50%;
          width: 200%;
          height: 200%;
          background: transparent;
          animation: none;
        }
        
        .connect-content {
          position: relative;
          z-index: 2;
          color: #333;
          max-width: 600px;
          margin: 0 auto;
        }
        
        .connect-icon {
          font-size: 80px;
          color: #6c757d;
        }
        
        .connect-content h3 {
          font-size: 36px;
          font-weight: bold;
          margin-bottom: 20px;
          color: #333;
        }
        
        .connect-content p {
          font-size: 18px;
          margin-bottom: 40px;
          color: #6c757d;
          line-height: 1.6;
        }
        
        .full-page-connect-btn {
          background: linear-gradient(135deg, #b20d12, #8a0a0f);
          color: white;
          padding: 20px 50px;
          border-radius: 50px;
          font-size: 20px;
          font-weight: bold;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          gap: 15px;
          transition: all 0.3s ease;
          box-shadow: 0 10px 30px rgba(178, 13, 18, 0.3);
          text-transform: uppercase;
          letter-spacing: 1px;
        }
        
        .full-page-connect-btn:hover {
          transform: translateY(-5px) scale(1.05);
          box-shadow: 0 20px 40px rgba(178, 13, 18, 0.4);
          color: white;
          text-decoration: none;
        }
        
        .full-page-connect-btn i {
          font-size: 18px;
          transition: transform 0.3s ease;
        }
        
        .full-page-connect-btn:hover i {
          transform: translateX(5px);
        }
        
        @keyframes pulse {
          0%, 100% {
            opacity: 0.3;
            transform: scale(1);
          }
          50% {
            opacity: 0.6;
            transform: scale(1.1);
          }
        }
        
        @media (max-width: 768px) {
          .full-page-connect-section {
            padding: 30px 20px;
            margin: 15px 0;
          }
          
          .connect-icon {
            font-size: 60px;
          }
          
          .connect-content h3 {
            font-size: 28px;
          }
          
          .connect-content p {
            font-size: 16px;
          }
          
          .full-page-connect-btn {
            padding: 18px 40px;
            font-size: 18px;
          }
        }
      `}</style>

      {/* Aluminees Section - White background, no images */}
      <style>{`
        .alumnees-section {
          background: transparent;
          border-radius: 18px;
          box-shadow: none;
          margin: 40px 0;
          padding: 40px 0 70px 0;
        }
        .alumnee-list {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 32px;
        }
        .alumnee-card {
          background: transparent;
          border-radius: 16px;
          box-shadow: none;
          transition: transform 0.2s, box-shadow 0.2s;
          min-height: 140px;
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
          padding: 28px 28px 18px 28px;
        }
        .alumnee-card:hover {
          transform: translateY(-8px) scale(1.02);
          box-shadow: none;
        }
        .alumnee-photo {
          margin-bottom: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .alumnee-photo img {
          width: 110px;
          height: 110px;
          border-radius: 50%;
          object-fit: cover;
          box-shadow: 0 2px 8px rgba(60,72,88,0.15);
        }
        .alumnee-details {
          width: 100%;
          text-align: center;
        }
        .alumnee-details h4 {
          font-size: 1.25rem;
          font-weight: 600;
          margin-bottom: 6px;
          color: #3730a3;
        }
        .alumnee-details p {
          font-size: 1rem;
          margin: 2px 0;
          color: #444;
        }
        @media (max-width: 900px) {
          .alumnee-list {
            grid-template-columns: repeat(2, 1fr);
          }
        }
        @media (max-width: 600px) {
          .alumnee-list {
            grid-template-columns: 1fr;
          }
          .alumnee-card {
            flex-direction: column;
            width: 100%;
            min-height: unset;
            padding: 18px 10px;
          }
          .alumnee-photo {
            margin-right: 0;
            margin-bottom: 12px;
          }
        }
      `}</style>
      <div className="alumnees-section">
        <div className="container">
          <h2 style={{ textAlign: 'center', marginBottom: "50px", fontWeight: 700 }}>Aluminees Profile</h2>
          <div className="alumnee-list">
            {[
              {
                email: "deekshithkumar.ar@gmail.com",
                name: "Deekshith Kumar",
                course: "Architecture",
                year: "2020",
                company: "EVODE STUDIOS PVT.LTD",
                designation: "Associate principal architect",
                location: "Bangalore",
                package: "12 LPA"
              },
              {
                email: "sabari0306@gmail.com",
                name: "Sabari raja",
                course: "B.Arch",
                year: "2020",
                company: "MCLAREN CONSTRUCTION",
                designation: "Project Architect",
                location: "Dubai",
                package: "5 LPA"
              },
              {
                email: "ar.nadasubair@gmail.com",
                name: "Nada Subair",
                course: "M.arch",
                year: "2023",
                company: "KMCT College of Architecture",
                designation: "Assistant Professor",
                location: "Kozhikode",
                package: "3.6 LPA"
              },
              {
                email: "dharshansrisomu2001@gmail.com",
                name: "Dharshan Kumar",
                course: "B.Arch",
                year: "2024",
                company: "RSP Design Consultants (India) Pvt Ltd",
                designation: "Design Manager",
                location: "Bangalore",
                package: "4.8 LPA"
              },
              {
                email: "siddhur1998@gmail.com",
                name: "Siddharth Ramkumar",
                course: "B.Arch",
                year: "2020",
                company: "Studio Lotus",
                designation: "Senior Architect",
                location: "Delhi",
                package: "7 LPA"
              },
              {
                email: "habitus.works@gmail.com",
                name: "Srinath Soundararajan",
                course: "B.Arch",
                year: "2019",
                company: "Habitus | Interior. Architecture. Graphics.",
                designation: "Founder & Chief Architect",
                location: "Coimbatore",
                package: "2.4 LPA"
              },
              {
                email: "merwinanand@gmail.com",
                name: "Merwin Anand F",
                course: "B.ARCH",
                year: "2024",
                company: "WHITE EDGE ARCHITECTS",
                designation: "JUNIOR ARCHITECT",
                location: "MADURAI",
                package: "2.5 LPA"
              },
              {
                email: "haresh@nomadarchitects.in",
                name: "Haresh Raghunathan",
                course: "B.Arch",
                year: "2016",
                company: "Nomad Architects",
                designation: "Principal Architect",
                location: "Coimbatore",
                package: "1.8 LPA"
              },
              {
                email: "binjo.dja@gmail.com",
                name: "Binjo Babu Arimbilly",
                course: "B Arch",
                year: "2013",
                company: "About Tomorrow",
                designation: "Principal Architect",
                location: "Kochi",
                package: "10 LPA"
              },
              {
                email: "raja98.archi@gmail.com",
                name: "Rajaghanapathy",
                course: "Architecture",
                year: "2020",
                company: "Khatib alami",
                designation: "Architect",
                location: "Banglore",
                package: "4 LPA"
              },
              {
                email: "ar.srinath97@gmail.com",
                name: "Srinath Soundararajan",
                course: "B.Arch",
                year: "2019",
                company: "HABITUS | Interior. Architecture. Graphics.",
                designation: "Founder & Chief Architect",
                location: "Ganapathy, Coimbatore, Tamil Nadu, India",
                package: "2 LPA"
              },
              {
                email: "cdsarath@gmail.com",
                name: "Sarath chandran",
                course: "B.Arch",
                year: "2017",
                company: "Dynamic Design DMCC",
                designation: "Project Coordinator",
                location: "Dubai - UAE",
                package: "43.2 LPA"
              },
              {
                email: "jk.approvals@gmail.com",
                name: "Vinoth Kumar J",
                course: "B.Arch",
                year: "2017",
                company: "JK's Architect & Consultants",
                designation: "Proprietor",
                location: "Sivakasi",
                package: "Own Business"
              }
            ].map((alumnee, idx) => {
              let imgSrc = "assets/images/Mccans icon.svg";
              if (idx > 0 && idx <= 12) {
                imgSrc = `assets/images/alumini/aluminees/${idx + 1}.webp`;
              }
              return (
                <div className="alumnee-card" key={idx}>
                  <div className="alumnee-photo">
                    <img src={imgSrc} alt={alumnee.name + ' profile'} width={110} height={110} />
                  </div>
                  <div className="alumnee-details">
                    <h4>{alumnee.name}</h4>
                    {/* <p><strong>Email:</strong> {alumnee.email}</p>
                    <p><strong>Course:</strong> {alumnee.course}</p>
                    <p><strong>Year of Passed Out:</strong> {alumnee.year}</p> */}
                    <p><strong>Company:</strong> {alumnee.company}</p>
                    <p><strong>Designation:</strong> {alumnee.designation}</p>
                    <p><strong>Location:</strong> {alumnee.location}</p>
                    <p><strong>Package (LPA):</strong> {alumnee.package}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};
